import TierGrid from "./tier-grid";

interface Props {
  hideHeader?: boolean;
}

export default function ResidentialPricingTiers({ hideHeader = false }: Props) {
  return (
    <section
      id="pricing-tiers"
      className={`border-border relative overflow-hidden border-b ${hideHeader ? "pb-section pt-0" : "py-section"}`}
      {...(hideHeader
        ? { "aria-label": "Pricing tiers" }
        : { "aria-labelledby": "residential-pricing-tiers-heading" })}
    >
      <div
        className="pointer-events-none absolute top-0 left-1/2 h-[400px] w-[700px] -translate-x-1/2 rounded-full opacity-[0.06] blur-3xl"
        style={{
          background:
            "radial-gradient(ellipse, color-mix(in srgb, var(--brand-green) 10%, transparent) 0%, transparent 70%)",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {!hideHeader && (
          <div className="mx-auto mb-12 max-w-2xl text-center">
            <p className="text-muted-foreground mb-3 text-sm font-medium">Pick Your Volume</p>
            <h2
              id="residential-pricing-tiers-heading"
              className="text-foreground mb-4 text-3xl font-bold tracking-tight sm:text-4xl"
            >
              Plans that scale with you.
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed">
              Start with a ready-made plan, or scale into higher-volume tiers — the price per GB
              drops as you grow.
            </p>
          </div>
        )}

        <div className="mx-auto max-w-6xl">
          <TierGrid />
        </div>
      </div>
    </section>
  );
}
